import { EventEmitter, Injectable } from '@angular/core';
import { UnitsSettings } from '../models/unitsSettings';
import { UserPreferences } from '../models/user-preferences';

@Injectable({
  providedIn: 'root'
})
export class EventBroadcastService {

  public userPreferencesUpdatedEvent: EventEmitter<UserPreferences>;

  constructor() {
    this.userPreferencesUpdatedEvent = new EventEmitter();
  }

  broadcastPreferencesUpdated(unitSettings: UserPreferences) {
    this.userPreferencesUpdatedEvent.emit(unitSettings);
  }


}
